import { add, startOfToday } from "date-fns";

export function getDateAdjusted(offsetDays: number): Date {
    return add(startOfToday(), {
        days: offsetDays,
    });
}

export function getDateStringAdjusted(offsetDays: number): string {
    var dt = add(startOfToday(), {
        days: offsetDays,
    });

    return dt.toISOString();
}

export function getUtcDateStringWithoutOffset(dt: Date): string {
    var month = (dt.getMonth() + 1).toString().padStart(2, "0");
    var day = dt.getDate().toString().padStart(2, "0");
    var dtUtc = `${dt.getFullYear()}-${month}-${day}T00:00:00.000Z`;
    return dtUtc;
}

export function getLocalIsoDateWithNoTime(rawDate: Date): string {
    const pad = (n: number) => {
        return n < 10 ? "0" + n : n;
    };

    const date = new Date(rawDate);
    if (!(date instanceof Date)) {
        return "";
    }

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    return `${year}-${month}-${day}T00:00:00.000`;
}

export function parseDateAsLocal(date: Date): Date {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}
